import axios from 'axios'

// 角色管理分页查询
export function queryRolePage (datas) {
  const url = `/customerPermission/queryRolePage`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 角色管理新增菜单按钮查询
export function queryRolePermission (datas) {
  const url = `/customerPermission/queryRolePermission`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 角色管理恢复/禁用
export function deleteRole (datas) {
  const url = `/customerPermission/deleteRole`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 角色管理新增
export function addRole (datas) {
  const url = `/customerPermission/addRole`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 角色管理编辑权限提交
export function editRole (datas) {
  const url = `/customerPermission/editRole`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 角色编辑回显
export function editRoleReturn (datas) {
  const url = `/customerPermission/editRoleReturn`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/power/role.js